import "babel-polyfill";
import Vue from "vue";
import Vuex from "vuex";
import vuetify from "@/plugins/vuetify";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "@mdi/font/css/materialdesignicons.css";
import "./plugins/toast.js";
import _ from "lodash";
import VuetifyConfirm from "vuetify-confirm";
import VueMobileDetection from "vue-mobile-detection";

Object.defineProperty(Vue.prototype, "$lodash", { value: _ });

// cf. https://www.npmjs.com/package/vue-mobile-detection
Vue.use(VueMobileDetection);

// cf. https://fr.vuejs.org/v2/guide/plugins.html#Utiliser-un-plugin
Vue.use(Vuex);

// cf. https://www.npmjs.com/package/vuetify-confirm
Vue.use(VuetifyConfirm, {
  vuetify,
  buttonTrueText: "Oui",
  buttonFalseText: "Non",
  color: "warning",
  icon: "warning",
  title: "Attention",
  width: 350,
  property: "$confirm",
});

// cf. https://fr.vuejs.org/v2/api/index.html#productionTip
Vue.config.productionTip = false;

new Vue({
  vuetify,
  store,
  router,
  _,
  render: (h) => h(App),
}).$mount("#app");
